module.exports = "/remote-dist/544900cb432cd56cb9785a4b487d4315.jpg";